<template>
  <super-admin-layout>
    <v-container fluid>
      <v-layout row wrap>
        <v-row style="margin-bottom: 44px">
          <v-col cols="12" md="2"></v-col>
          <v-col cols="12" md="8" style="display: flex; gap: 1em">
            <div class="reporting_div" style="display: flex; gap: 0.5em">
              <div class="text-xs-center px-0 mx-auto">
                <strong>Total Users:</strong>
              </div>
              <div class="text-xs-center px-0 mx-auto">{{ totalUsers }}</div>
            </div>
            <div class="reporting_div" style="display: flex; gap: 0.5em">
              <div class="text-xs-center px-0 mx-auto">
                <strong>Total Courses:</strong>
              </div>
              <div class="text-xs-center px-0 mx-auto">{{ totalCourses }}</div>
            </div>
          </v-col>
          <v-col cols="12" md="2"></v-col>
          <v-col cols="12" md="2"></v-col>
          <v-col cols="12" md="4">
            <v-card flat height="100%">
              <v-card-text class="px-0">
                <h3>Most Popular</h3>
                <template v-if="reportLoading">
                  <div class="text-center" fluid style="position: relative;width: 100%;margin-top: 25px;">
                    <v-skeleton-loader class="mx-auto mt-5" type="image"></v-skeleton-loader>
                  </div>
                </template>
                <template v-else>
                <apexchart
                  :options="barChartOptions"
                  :series="barSeries"
                  type="bar"
                  height="350"
                />
                </template>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card flat height="100%">
              <v-card-text class="px-0">
                <h3>Completed Courses</h3>
                <apexchart
                  :options="pieChart.chartOptions"
                  :series="pieChart.series"
                  type="donut"
                  width="380"
                  v-if="pieChart.series.length >  1"
                />
                <div class="text-center" v-else  fluid style="position: relative;width: 100%;margin-top: 25px;">
                  <v-skeleton-loader class="mx-auto mt-5" type="image"></v-skeleton-loader>
              </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="2"></v-col>
        </v-row>
      </v-layout>
      <v-row>
        <v-col md="12">
          <v-card flat>
            <v-card-title>
              <div class="flex-grow-1"></div>
            </v-card-title>
            <v-skeleton-loader v-if="loading && isTabletOrDesktop" type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
            <v-data-table
              :headers="headers"
              :options.sync="options"
              :server-items-length="serverItemsLength"
              v-show="!loading"
              :items="users"
            >
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </super-admin-layout>
</template>

<script>
import userAPI from '@/api/partner.js';
import SuperAdminLayout from '@/layouts/SuperAdmin';
import VueApexCharts from 'vue-apexcharts';
export default {
  name: 'UsersReport',
  components: {
    SuperAdminLayout,
    apexchart: VueApexCharts,
  },
  data() {
    return {
      headers: [
        { text: 'First Name', value: 'first_name' },
        { text: 'Surname', value: 'last_name' },
        { text: 'Email', value: 'email' },
        { text: 'Last Login', value: 'last_login', sortable: false },
        { text: 'Total Users', value: 'total_customer_users', sortable: false },
        {
          text: 'Total Courses',
          value: 'total_customer_courses',
          sortable: false,
        },
        {
          text: 'Total Groups',
          value: 'total_customer_groups',
          sortable: false,
        },
        {
          text: 'Total Playlists',
          value: 'total_customer_playlists',
          sortable: false,
        },
      ],
      users: [],
      search: '',
      searchParams: '',
      pagination: {},
      options: {},
      loading: false,
      totalUsers: 0,
      totalCourses: 0,
      bar: {},
      pie: {},
      pieChart: {
        series: [0],
        chartOptions: {
          dataLabels: {
            enabled: false,
          },
          labels: ['Not Started', 'Completed', 'In progress'],
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200,
                },
                legend: {
                  show: false,
                },
              },
            },
          ],
          legend: {
            position: 'right',
            offsetY: 0,
            height: 230,
          },
        },
      },
      barData: {
        series: [], // Initialize with an empty array
        categories: []
      },
      reportLoading: false,
      companyName: ''
    };
  },
  computed: {
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      return this.$gf.getQueryString(this.options, this.serverItemsLength);
    },
    barSeries() {
      return  this.barData.series.length ? [
        {
          name: 'Total Users',
          data: this.barData.series,
        },
      ] : [];
    },
    barChartOptions() {
      return {
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        tooltip: {
          enabled: false,
        },
        chart: {
        toolbar: {
            show: true,
            tools: {
              download: true
            },
            export: {
              csv: {
                filename: `Most_Popular_Courses_${this.companyName}_${new Date().toISOString().slice(0, 19).replace(/[-T:]/g, "_")}`, // Custom filename
                columnDelimiter: ",",
                headerCategory: "Courses", // Custom X-axis title
                headerValue: "Total Users Assigned", // Custom Y-axis title
              }
           }
          },
        },
        xaxis: {
          categories: this.barData.categories.length ? this.barData.categories : [],
          tickAmount: 3,
          labels: {
            formatter: function (val) {
              return val.toFixed(0);
            },
          },
        },
      };
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  watch: {
    options: {
      handler() {
        this.getCustomers();
      },
      deep: true,
    },
  },
  mounted(){
    this.getReports();
  },
  methods: {
    getCustomers() {
      this.loading = true;
      userAPI
        .getOwners(this.params, this.searchParams, this.$route.params.id)
        .then((resp) => {
          this.users = resp.data.data;
          this.pagination = resp.data.meta.pagination;
          if (resp.data.data.length > 0) {
            this.totalUsers = 0; this.totalCourses = 0;
            for (var i = 0; i < resp.data.data.length; i++) {
              this.totalUsers =
                this.totalUsers + resp.data.data[i].total_customer_users;
              this.totalCourses =
                this.totalCourses + resp.data.data[i].total_customer_courses;
            }
          }
          this.loading = false;
        });
    },
    resetSearch() {
      this.searchParams = '';
      this.getCustomers();
    },
    applySearch() {
      this.searchParams =
        this.params +
        '&search=first_name:' +
        this.search +
        ';last_name:' +
        this.search;
      this.getCustomers();
    },
    pieC() {
      this.pieChart = {
        series: this.pie.map((x) => {
          return x;
        }),
      };
    },
    getReports() {
      this.reportLoading = true;
      userAPI
        .getPartnerCustomerReports(this.$route.params.id)
        .then((response) => {
          this.reportLoading = false;
          if (response.data) {
            this.barData = {
                series: response.data.bar ? response.data.bar.series : [0],
                categories:  response.data.bar ? response.data.bar.categories : [0]
              };

            let pieChartSeries = response.data.pie.map((x) => {
                    return x;
                })
            this.pieChart.series = pieChartSeries;

            this.companyName = response.data.company_name;
          }
        });
    },
  },
};
</script>
